/**
 * 認証エラー例外.
 */
export default class UnauthorizedException extends Error {}
